import { render, staticRenderFns } from "./EditJournalContentGroup.vue?vue&type=template&id=003cd2af&scoped=true"
import script from "./EditJournalContentGroup.vue?vue&type=script&lang=js"
export * from "./EditJournalContentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003cd2af",
  null
  
)

export default component.exports